export const START_MEETING = '/api/chat/start-call';
export const REJECT_CALL = '/api/chat/reject-call';
export const ACCEPT_CALL = '/api/chat/accept-call';
export const END_CALL = '/api/chat/end-call';
export const INVITE_CALL = '/api/chat/invite-call';
